"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MerchantProfileContract = void 0;
const contract_1 = require("../base/contract");
const profile_schemas_1 = require("../../schemas/merchant/profile.schemas");
const api_schemas_1 = require("../../schemas/base/api.schemas");
exports.MerchantProfileContract = (0, contract_1.createContract)({
    name: 'MerchantProfile',
    baseUrl: '/merchants',
    version: '1',
    serviceModule: 'merchant',
    endpoints: {
        getMerchantProfile: {
            method: 'GET',
            path: '/:merchantId',
            body: null,
            query: null,
            params: profile_schemas_1.getMerchantProfileParamsSchema,
            headers: null,
            response: {
                success: profile_schemas_1.getMerchantProfileResponseSchema,
                errors: {
                    unauthorized: api_schemas_1.baseErrorResponseSchema,
                    forbidden: api_schemas_1.baseErrorResponseSchema,
                    notFound: api_schemas_1.baseErrorResponseSchema,
                },
            },
            middleware: ['auth:required', 'merchant:member'],
            documentation: {
                summary: 'Get merchant profile',
                description: 'Retrieves the merchant profile information. Requires membership in the merchant.',
                tags: ['Merchant', 'Profile'],
                deprecated: false,
            },
            tests: [
                'should return merchant profile for authenticated merchant member',
                'should return 401 for unauthenticated request',
                'should return 403 for non-member',
                'should return 404 for non-existent merchant',
            ],
        },
        updateMerchantProfile: {
            method: 'PATCH',
            path: '/:merchantId',
            body: profile_schemas_1.updateMerchantProfileBodySchema,
            query: null,
            params: profile_schemas_1.updateMerchantProfileParamsSchema,
            headers: null,
            response: {
                success: profile_schemas_1.updateMerchantProfileResponseSchema,
                errors: {
                    unauthorized: api_schemas_1.baseErrorResponseSchema,
                    forbidden: api_schemas_1.baseErrorResponseSchema,
                    validationError: api_schemas_1.baseErrorResponseSchema,
                },
            },
            middleware: ['auth:required', 'merchant:admin'],
            documentation: {
                summary: 'Update merchant profile',
                description: 'Updates merchant profile (name, description, logo). Requires merchant admin role.',
                tags: ['Merchant', 'Profile'],
                deprecated: false,
            },
            tests: [
                'should update merchant name',
                'should update merchant description',
                'should update logo_url after upload',
                'should return 403 for non-admin member',
            ],
        },
    },
});
